import React from "react";

function SnapPill({ variant, children }) {
  return (
    <span className={`snap-pill ${variant}`}>{children}</span>
  );
}

function OperationsSnapshot({ complaintsData, workforceData, workforceLoading, rangeLabel, proceduresData, onComplaintsClick, onProceduresClick, onWorkforceClick }) {
  const { total: compTotal = 0, customerSupport = 0, public: pub = 0, independentEngineer = 0 } = complaintsData || {};
  const compSources = [
    { label: "CS", value: customerSupport, color: "#305878" },
    { label: "Public", value: pub, color: "#3d7a50" },
    { label: "IE", value: independentEngineer, color: "#5a3878" },
  ];
  const sourceTotal = compSources.reduce((s, c) => s + c.value, 0) || 1;

  const { present = 0, absent = 0 } = workforceData || {};
  const { positive = 0, negative = 0 } = proceduresData || {};
  const procTotal = positive + negative;

  return (
    <div data-cy="ops-snapshot">
      {/* Complaints */}
      <div className="snap-row" data-cy="snap-row-complaints" onClick={onComplaintsClick} style={onComplaintsClick ? { cursor: "pointer" } : undefined}>
        <div className="snap-icon">
          <svg viewBox="0 0 24 24">
            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
          </svg>
        </div>
        <div className="snap-body">
          <div className="snap-name">Complaints — <strong>{compTotal}</strong></div>
          <div className="snap-pills">
            <SnapPill variant="neutral">{compTotal} total</SnapPill>
            {customerSupport > 0 && <SnapPill variant="info">{customerSupport} CS</SnapPill>}
            {pub > 0 && <SnapPill variant="ok">{pub} public</SnapPill>}
            {independentEngineer > 0 && <SnapPill variant="neutral">{independentEngineer} IE</SnapPill>}
          </div>
          {compTotal > 0 && (
            <div style={{ display: "flex", height: "3px", marginTop: "8px", gap: "1px" }}>
              {compSources.filter(s => s.value > 0).map((src) => (
                <div
                  key={src.label}
                  style={{ flex: src.value / sourceTotal, background: src.color, height: "100%" }}
                />
              ))}
            </div>
          )}
        </div>
      </div>

      {/* Workforce */}
      <div className="snap-row" data-cy="snap-row-workforce" onClick={onWorkforceClick} style={onWorkforceClick ? { cursor: "pointer" } : undefined}>
        <div className="snap-icon">
          <svg viewBox="0 0 24 24">
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
            <circle cx="9" cy="7" r="4" />
            <path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" />
          </svg>
        </div>
        <div className="snap-body">
          <div className="snap-name">Workforce — <strong>{workforceLoading ? "—" : present}</strong> employees captured</div>
          <div className="snap-pills">
            <SnapPill variant="ok">{workforceLoading ? "—" : present} captured</SnapPill>
            {absent > 0 && <SnapPill variant="bad">{absent} absent</SnapPill>}
            {rangeLabel && <SnapPill variant="neutral">{rangeLabel}</SnapPill>}
          </div>
        </div>
      </div>

      {/* Procedures */}
      <div className="snap-row" data-cy="snap-row-procedures" onClick={onProceduresClick} style={onProceduresClick ? { cursor: "pointer" } : undefined}>
        <div className="snap-icon">
          <svg viewBox="0 0 24 24">
            <polyline points="9,11 12,14 22,4" />
            <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" />
          </svg>
        </div>
        <div className="snap-body">
          <div className="snap-name">Procedures — <strong>{procTotal}</strong> completed</div>
          <div className="snap-pills">
            <SnapPill variant="neutral">{procTotal}</SnapPill>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OperationsSnapshot;
